import { useEffect, useState } from "react";
import { Reveal } from "./motion-primitives";
import { SectionHeading } from "./SectionHeading";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TestimonialCard = ({ t, delay }) => (
  <Reveal delay={delay}>
    <figure
      className="flex h-full flex-col justify-between border border-charcoal bg-charcoal/20 p-8 sm:p-10"
      data-testid={`testimonial-${t.id}`}
    >
      <blockquote className="font-serif text-2xl font-light leading-snug text-cream/90 sm:text-3xl">
        “{t.long_feedback}”
      </blockquote>
      <figcaption className="mt-8 border-t border-charcoal pt-6">
        <p className="font-sans text-sm uppercase tracking-[0.16em] text-cream">{t.traveller_name}</p>
        <p className="mt-1 font-sans text-xs uppercase tracking-[0.18em] text-sand">
          {[t.destination, t.trip_duration, t.trip_type].filter(Boolean).join(" · ")}
        </p>
      </figcaption>
    </figure>
  </Reveal>
);

// Curated social proof — editorial, no stars or review-platform styling.
export const TravellerNotes = () => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    let active = true;
    fetch(`${API}/testimonials?featured=true`)
      .then((r) => (r.ok ? r.json() : { testimonials: [] }))
      .then((d) => active && setItems(d.testimonials || []))
      .catch(() => active && setItems([]));
    return () => {
      active = false;
    };
  }, []);

  if (items !== null && items.length === 0) return null;

  return (
    <section
      id="traveller-notes"
      data-testid="traveller-notes-section"
      className="border-t border-charcoal"
    >
      <div className="mx-auto max-w-[1400px] px-6 py-16 sm:px-10 lg:px-16 lg:py-20">
        <SectionHeading
          overline="Traveller notes"
          title="Trips we've helped shape."
          testId="traveller-notes-heading"
        />
        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-2 lg:mt-14 lg:gap-8" data-testid="testimonials-grid">
          {(items || []).map((t, i) => (
            <TestimonialCard key={t.id} t={t} delay={i * 0.1} />
          ))}
        </div>
      </div>
    </section>
  );
};
